import { observer } from "mobx-react";
import { Box, List, ListItem } from "@mui/material";
import WhiteCardTitle from "../typographies/WhiteCardTitle";
import WhiteCardInfo from "../typographies/WhiteCardInfo";
import { useStoreContext } from "../..";
import { useEffect } from "react";
import LatestLabel from "./details/LastestLabel";
import SummaryFrame from "./details/SummaryFrame";
import SummaryContent from "./details/SummaryContent";
import ImmunoglobulinDetails from "./details/ImmunoglobulinDetails";

const ImmunoglobulinSummary = observer(() => {
  const { immunoglobulinStore, drugStore, fieldStore, formStore } =
    useStoreContext();

  useEffect(() => {
    if (formStore.forms && !immunoglobulinStore.immunoglobulins) {
      immunoglobulinStore.getImmunoglobulins();
    }
  }, [formStore.forms, immunoglobulinStore.immunoglobulins]);

  useEffect(() => {
    if (!drugStore.drugs) {
      drugStore.getDrugs();
    }
  }, [drugStore.drugs]);

  const dataReady = Boolean(
    immunoglobulinStore.immunoglobulins &&
      drugStore.drugs &&
      fieldStore.mappedSideEffects &&
      fieldStore.mappedDrugs
  );
  const latestImmunoGlobulins = immunoglobulinStore.latestImmunoglobulins;

  return (
    <SummaryFrame>
      <Box className="flex-row-center-start">
        <WhiteCardTitle text="Immunoglobulin" />
      </Box>
      <LatestLabel />
      <SummaryContent>
        {dataReady && latestImmunoGlobulins.length === 0 && (
          <WhiteCardInfo text="Inga registreringar" />
        )}
        {dataReady && latestImmunoGlobulins.length > 0 && (
          <List disablePadding={true} dense={true}>
            {latestImmunoGlobulins.map((item, index) => (
              <ListItem key={index} sx={{ padding: 0, marginBottom: 1 }}>
                <ImmunoglobulinDetails immunoglobulin={item} />
              </ListItem>
            ))}
          </List>
        )}
      </SummaryContent>
    </SummaryFrame>
  );
});

export default ImmunoglobulinSummary;
